import { useEffect, useState } from "react";
import logo from "../assets/logo.png";

const NAV_ITEMS = [
  { label: "Start", href: "#hero" },
  { label: "Über mich", href: "#ueber-mich" },
  { label: "Angebot", href: "#behandlungen" },
  { label: "Ablauf", href: "#ablauf" },
  { label: "Lernen", href: "#lernen" },
  { label: "Kontakt", href: "#kontakt" },
];

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-sand-50/90 backdrop-blur-md border-b border-stone-800/8"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 lg:px-10">
        <div className="flex items-center justify-between h-20">
          <a href="#hero" className="flex items-center gap-2.5 group">
            <img src={logo} alt="ziel balance" className="h-14 w-auto transition-transform duration-500 group-hover:scale-105" />
          </a>

          <nav className="hidden md:flex items-center gap-5 lg:gap-7">
            {NAV_ITEMS.map(({ label, href }) => (
              <a
                key={href}
                href={href}
                className="text-sm text-stone-700 hover:text-sage-700 transition-colors duration-200 font-medium"
              >
                {label}
              </a>
            ))}
          </nav>

          <a
            href="#kontakt"
            className="hidden md:inline-flex items-center gap-2 text-sm bg-stone-900 hover:bg-sage-700 text-sand-50 px-5 py-2.5 transition-colors duration-200 font-medium"
          >
            Termin anfragen
          </a>

          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5 text-stone-800"
            aria-label="Menu"
          >
            <span className={`block w-5 h-[1.5px] bg-current transition-all duration-300 ${menuOpen ? "rotate-45 translate-y-[5px]" : ""}`} />
            <span className={`block w-5 h-[1.5px] bg-current transition-all duration-300 ${menuOpen ? "opacity-0" : ""}`} />
            <span className={`block w-5 h-[1.5px] bg-current transition-all duration-300 ${menuOpen ? "-rotate-45 -translate-y-[5px]" : ""}`} />
          </button>
        </div>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-400 ${
          menuOpen ? "max-h-80 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <nav className="bg-sand-50/98 backdrop-blur-md border-t border-stone-800/8 px-6 py-5 flex flex-col gap-4">
          {NAV_ITEMS.map(({ label, href }) => (
            <a
              key={href}
              href={href}
              onClick={() => setMenuOpen(false)}
              className="text-sm text-stone-700 hover:text-sage-700 transition-colors duration-200 font-medium"
            >
              {label}
            </a>
          ))}
          <a
            href="#kontakt"
            onClick={() => setMenuOpen(false)}
            className="inline-flex w-fit text-sm bg-stone-900 text-sand-50 px-5 py-2.5 font-medium"
          >
            Termin anfragen
          </a>
        </nav>
      </div>
    </header>
  );
}
